import { Invoice, Paginator } from '@/types'
import { requests } from '../http/axios'
import { removeNullParams } from '@/helper/formatter'

interface GetInvoicesParams {
  page?: number
  limit?: number
  status?: string
  startDate?: string
  endDate?: string
  userId?: number
}

export class InvoiceService {
  /**
   * 获取当前用户的所有发票
   */
  static async getInvoices(
    params: GetInvoicesParams = {}
  ): Promise<Paginator<Invoice>> {
    return await requests.get(
      '/invoices?' + removeNullParams(params).toString()
    )
  }

  /**
   * 获取特定发票的详情
   */
  static async getInvoice(id: number): Promise<Invoice> {
    return await requests.get(`/admin/invoices/${id}`)
  }

  static async markAsPaid(id: number): Promise<void> {
    return await requests.patch(`/admin/invoices/${id}/mark-as-paid`, {})
  }

  static async markAsUnpaid(id: number): Promise<void> {
    return await requests.patch(`/admin/invoices/${id}/mark-as-unpaid`, {})
  }
}
